export const url = {
  getLibAll: "libs",
  signup: "/user/signup",
  signin: "/user/signin",
  contactUs: "contact-us",
  getLibFullDetails: "libs/",
  userVerify: "/user/verify",
  logout: "/user/refresh-token",
  getHighlightLib: "highlights/lib/",
  getHighlightCarousel: "/highlights/landing",
  bioInfoRequest: "bio-info-request",
  refreshToken: "/user/refresh-token",
  resetPassword: "user/reset-password",
  getCompoundsCount: "/libs/compounds-count",
  resetPasswordRequest: "user/reset-password/request",

  payments: '/payments/v1/payments/hosted-page',

  img: "libs/media/img/",
  download: "libs/media/download",
  downloadLib: convertLibsUrl,
  smi2pict: "/smi2pict",
  chemutils: "/chemutils/smiles-image",

  refresh: "user/access-token/refresh",

  resendMail: "user/resend-mail/",
  
  ebcIdByAny: "/ebc/ebcId-by-any",

  searchLib: "/libs/search",
  search: "/ebc/search-released",
  getSearchCompoundById: "ebc/catalog/",
  getCitationById: (ebcId: string) => `ebc/catalog/${ebcId}/citations`,
  searchListByIds: "/ebc/catalog/by-any-ids",
  chemutilsConvertStructure: "chemutils/convert-from-mrv",
  ebcCatalogRelatedCompounds: convertEbcCatalogRelatedCompounds,

  compoundsSimilarity: "/ebc/structure-search/similarity",
  compoundsSubstructure: "/ebc/structure-search/substructure",
  compoundsFullfragment: "/ebc/structure-search/fullfragment",

  linkersSimilarity: "linkers/structure-search/similarity",
  linkersFullfragment: "linkers/structure-search/fullfragment",
  linkersSubstructure: "linkers/structure-search/substructure",

  projects: "/profile/projects",

  getOrders: "/profile/orders",
  addresses: "/profile/addresses",
  usaStates: "/addresses/usa-states",
  addressesCountries: "addresses/countries",

  profileUpdate: "profile/users/current",
  profile: "profile/users/current/avatar",

  getTargetDetailsById: "/targets/",
  getBaDataTargets: "/targets/ba-data",
  getThesaurusById: "/targets/thesaurus",
  searchThesaurus: "/targets/thesaurus/search",

  baDataMainActivity: "/ba-data/main-activity",

  drugImpurity: "/ebc/drug-impurity",
  chemicalProbes: "/ebc/chemical-probes",

  getProductsDictionary: "/ebc/drugs/dictionary",
  getProductDrugInfoById: (id: string) => `/ebc/drugs/${id}/impurities`,

  getCansByEbcId: (id: string) => `/ebc/catalog/${id}/cans`,
  getSolubilitiesByEbcId: (id: string) => `/ebc/catalog/${id}/solubilities`,

  getChemicalProbesById: 'ebc/chemical-probes',
  getInactiveControlById: '/compounds/inactive-control',

  ebcCategories: '/ebc/categories',
  getEbcCategoriesById: (id: string) => `/ebc/categories/${id}/compounds`,

  downloadSDFAnyIdsSdf: '/ebc/catalog/by-any-ids/sdf',
};

function convertEbcCatalogRelatedCompounds(id: string) {
  return `/ebc/catalog/${id}/related-compounds`;
}

function convertLibsUrl({ catNumber, type }: { catNumber: string, type: string }) {
  return `/libs/${catNumber}/files/${type}`;
}

export default url;